import { logger } from '@service-initiation/shared-clients-osp-logger';
import { type ServiceOption } from '@service-initiation/shared-clients-tech-care-services';

import { getDeviceTypeOptions } from './getDeviceTypeOptions';
import { getServiceOptions } from './getServiceOptions';
import { type GetRemoteTechEligibilityRequest, ServiceID } from './types';
import { type RemoteTechEligibilityAndOptions } from './types/RemoteTechEligibilityAndOptions';

export const getRemoteTechEligibilityAndOptions = async (
  payload: GetRemoteTechEligibilityRequest
): Promise<RemoteTechEligibilityAndOptions> => {
  try {
    // eslint-disable-next-line no-restricted-globals
    const queryParams: URLSearchParams = new URLSearchParams(location.search);
    let deviceTypeOptions = undefined;
    const deviceTypeFromUrl = parseInt(
      queryParams.get('device_option_ids') as string
    ) as number;
    if (!deviceTypeFromUrl) {
      deviceTypeOptions = await getDeviceTypeOptions({
        countryId: payload.countryId,
        deviceRepairId: payload.deviceRepairId,
        partnerId: payload.partnerId,
      });
    }
    const serviceOptions = await getServiceOptions({
      device_type_option_ids: deviceTypeFromUrl
        ? [deviceTypeFromUrl]
        : deviceTypeOptions?.option_types.reduce(
            (acc, { options = [] }): number[] => [
              ...acc,
              ...options.reduce(
                (acc, { option_ids = [] }): number[] => [...acc, ...option_ids],
                [] as number[]
              ),
            ],
            [] as number[]
          ),
      deviceRepairId: payload.deviceRepairId,
      postal_code: payload.postal_code,
    });

    const remoteTechOption = serviceOptions.data.find(
      (service: ServiceOption) => service.id === ServiceID.RT
    );

    return {
      eligibilityReason: remoteTechOption?.reason_not_available,
      isEligible: remoteTechOption?.available || false,
      options: remoteTechOption,
    };
  } catch (err) {
    logger.error(err as Error);
    return {
      eligibilityReason: undefined,
      isEligible: false,
      options: undefined,
    };
  }
};
